import * as React from 'react';

export const Footnote = ({children}: {children: React.ReactNode}) => <p style={{margin: 20}}>{children}</p>;
